<div class="card shadow">
  <div class="card-body">
    <app-table-header-template
      [searchOptions]="CategoriesSearchOptions"
      [hideFilter]="true">
      <ng-container buttons>
        <div class="row row-align-items-center">
          <div class="col-auto">
            <div class="mt-1 reduce-size-90">
              <app-toggle-switch
                [class]="'table-switch'"
                [hideIcon]="true"
                [initialValue]="showInvisibleCategories()"
                [label]="'Show all'"
                [id]="'hideInactiveCategoriesSwitch'"
                (switchChange)="onToggleHideInVisible()">
              </app-toggle-switch>
            </div>
          </div>
          @if (canAddCategory()) {
            @if (!hasActiveConnection()) {
              <div class="col-auto">
                <a
                  routerLink="/accounting/integrations"
                  class="btn btn-light-on-white btn-sm">
                  Connect to sync
                </a>
              </div>
            }
            <div class="col-auto">
              <button
                (click)="addCategory()"
                type="button"
                id="addCategory"
                class="btn btn-primary btn-sm">
                Add a category
              </button>
            </div>
          } @else {
            <div class="col-auto">
              <button
                class="btn-primary btn btn-sm min-w-auto"
                id="syncContacts"
                title="Fetch new categories from your accounting software"
                (click)="syncCategories()"
                [disabled]="busySyncing()">
                @if (busySyncing()) {
                  <i class="spinner-border spinner-border-sm"></i>
                  &nbsp;Syncing
                } @else {
                  <i class="iconoir-refresh-double"></i>
                  &nbsp;Sync categories
                }
              </button>
            </div>
          }
        </div>
      </ng-container>
    </app-table-header-template>

    <!-- Table cells are not reflecting templates -->
    <app-table
      [columns]="columns"
      [getDataCallback]="getData"
      #table
      class="table-categories"
      emptyMessage="Your categories will appear here.">
      <ng-template
        #accountCell
        let-row="row">
        <span [ngClass]="{ 'opacity-25': !row.is_visible }">
          {{ row?.account?.code | emptyIndicator }}
          {{ row.account?.code ? ' - ' : '' }}
          {{ row.account?.name | emptyIndicator }}
        </span>
      </ng-template>

      <ng-template
        #categoryNameCell
        let-row="row">
        <span [ngClass]="{ 'opacity-25': !row.is_visible }"> {{ row.name }} </span>
      </ng-template>
      <ng-template
        #actionsCell
        let-row="row">
        <div class="row">
          <div class="col-auto">
            <button
              (click)="editCategory(row)"
              (keydown.arrowRight)="editCategory(row)"
              class="btn-action"
              title="Edit category">
              <i class="iconoir-edit-pencil"></i>
            </button>
          </div>
          <div class="col-auto">
            <div
              [ngbTooltip]="tooltipContent"
              [disableTooltip]="row.account"
              tooltipClass="custom-tooltip"
              placement="left">
              <button
                (click)="toggleVisibility(row)"
                [disabled]="!canAddCategory() && !row.account"
                class="btn-action"
                title="Toggle category visibility">
                <i
                  class="pays-svg-icon"
                  [ngClass]="row.is_visible ? 'ic-eye' : 'ic-eye-slash'"></i>
              </button>
              <ng-template #tooltipContent>
                Cannot activate a category <br />
                that is not imported from your <br />
                accounting software
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>
    </app-table>
  </div>
</div>
